<template>
  <base-layout :doSkipHeader="true">
    <template v-slot:main>
      <div v-if="user">
        <div class="grid grid-cols-12 gap-6">
          <div class="col-span-12 lg:col-span-12 bg-white shadow overflow-hidden sm:rounded-lg">
            <p class="text-3xl font-bold text-center mt-6">Purchase Order</p>
            <div class="flex flex-col sm:flex-row gap-6 p-6">
              <div class="w-full sm:w-1/3 flex flex-col h-full">
                <div class="bg-white shadow-lg rounded-2xl border border-gray-100 overflow-hidden flex-shrink-0">
                  <div class="bg-red-600 text-white px-4 py-4">
                    <h2 class="text-lg font-bold">Buyer & Seller Details</h2>
                  </div>
                  <div class="p-4 mt-1">
                    <div class="mb-4">
                      <div class="flex justify-between items-center">
                        <h2 class="text-lg mb-2 text-gray-800 font-bold">Buyer Details</h2>
                      </div>
                      <div class="text-sm text-gray-500">
                        <div class="flex items-center mb-1">
                          <span class="font-medium w-24">Name:</span>
                          <span>{{ form.buyer.name }}</span>
                        </div>

                        <div class="flex items-center mb-1">
                          <span class="font-medium w-24">Company:</span>
                          <span>{{ form.buyer.companyName }}</span>
                        </div>

                        <div class="flex items-center">
                          <span class="font-medium w-24">Phone:</span>
                          <span>{{ form.buyer.tel }}</span>
                        </div>
                      </div>
                    </div>
                    <hr>
                    <div class="my-4">
                      <div>
                        <div class="flex justify-between items-center">
                          <h2 class="text-lg mb-2 text-gray-800 font-bold">Seller Details</h2>
                          <!-- <p v-if="companyId && contacts" class="text-sm cursor-pointer"
                            :class="!editingSeller ? 'text-red-500' : 'text-green-500'" @click="toggleSellerEdit">
                            {{ editingSeller ? 'Save' : 'Change Seller' }}
                          </p> -->
                        </div>

                        <div class="text-sm text-gray-500">
                          <div class="flex items-center mb-1">
                            <span class="font-medium w-24">Name:</span>
                            <span v-if="!editingSeller">{{ form.seller.name }}</span>

                            <select v-else v-model="form.seller.name" class="border rounded px-2 py-1 w-full text-sm">
                              <option v-for="contact in contacts" :key="contact.name" :value="contact.name">
                                {{ contact.name }}
                              </option>
                            </select>
                          </div>

                          <div class="flex items-center mb-1">
                            <span class="font-medium w-24">Company:</span>
                            <span>{{ form.seller.companyName }}</span>
                          </div>

                          <div class="flex items-center">
                            <span class="font-medium w-24">Phone:</span>
                            <span>{{ form.seller.tel }}</span>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="bg-white mt-3 shadow-lg rounded-2xl border border-gray-100 overflow-hidden flex-1 hidden md:flex flex-col">
                  <div class="text-white px-4 py-2 bg-gray-400">
                    <h2 class="font-bold text-sm">How does a Purchase Order work?</h2>
                  </div>

                  <div class="p-4 mt-1 text-xs text-gray-700 text-justify space-y-2">
                    <p>1. Complete the Purchase Order form by providing all required order details.</p>
                    <p>2. Click <strong>Generate Purchase Order</strong> to generate your Purchase Order.</p>
                    <p>3. Once the Purchase Order has been generated, a copy will be sent to your email. You may also download a copy for your records.</p>
                    <p>4. After downloading the Purchase Order, send it to the seller to confirm the order details</p>
                  </div>

                  <p class="p-4 text-xs text-gray-700">
                    Please review all information carefully before submitting your Purchase Order.
                  </p>
                </div>
              </div>

              <div class="bg-white shadow-lg rounded-2xl w-full sm:w-2/3  border border-gray-100 overflow-hidden">
                <!-- Card Header -->
                <div class="bg-red-600 text-white px-4 py-4">
                  <h2 class="text-lg font-bold">Order Details</h2>
                </div>
                <div v-if="broadcastId" class="m-4 rounded">
                  <div class=" text-red-600 font-bold text-lg mb-4 h-auto">
                    Broadcast Details
                  </div>
                  <div v-if="broadcast" v-html="formattedSubject" class="break-words mb-10 clearfix"></div>
                  <div v-else class=" my-6 space-y-4 animate-pulse">
                    <!-- Rows -->
                    <div class="space-y-2">
                      <div class="h-5 sm:h-4 bg-gray-200 rounded w-32"></div>
                      <div class="h-5 sm:h-4 bg-gray-200 rounded w-56"></div>
                      <div class="h-5 sm:h-4 bg-gray-200 rounded w-52"></div>
                      <div class="h-5 sm:h-4 bg-gray-200 rounded w-52"></div>
                      <div class="h-5 sm:h-4 bg-gray-200 rounded w-52"></div>
                      <div class="h-5 sm:h-4 bg-gray-200 rounded w-40"></div>
                    </div>
                  </div>

                </div>
                <div>
                  <ValidationObserver ref="observer" v-slot="{ invalid }">
                    <form @submit.prevent="handleSubmit">
                      <div class="p-4">

                         <ValidationProvider name="Purchase Order No." rules="required" v-slot="{ errors }">
                          <div class="mb-4">
                            <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                              <label class="text-sm font-medium w-full sm:w-40">Purchase Order No.:</label>

                              <input type="text" v-model="purchaseOrderPayload.purchaseNo" ref="purchaseNoInput"
                                @input="sanitizePurchaseNo"
                                :class="[
                                'w-full border rounded px-3 py-2 focus:outline-none',
                                errors[0]
                                  ? 'border-red-500 focus:ring-2 focus:ring-red-400'
                                  : 'border-gray-300 focus:ring-2 focus:ring-blue-500'
                              ]" />
                            </div>

                            <div class="flex flex-row-reverse">
                              <p class="text-red-600 text-sm mt4" v-if="errors[0]">{{ errors[0] }}</p>
                            </div>
                          </div>
                        </ValidationProvider>

                        <ValidationProvider name="Buyer Email" rules="required|email" v-slot="{ errors }">
                          <div class="mb-4">
                            <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                              <label class="text-sm font-medium w-full sm:w-40">Buyer:</label>

                              <input type="email" v-model="form.buyer.email" :class="[
                                'w-full border rounded px-3 py-2 focus:outline-none',
                                errors[0]
                                  ? 'border-red-500 focus:ring-2 focus:ring-red-400'
                                  : 'border-gray-300 focus:ring-2 focus:ring-blue-500'
                              ]" />
                            </div>

                            <div class="flex flex-row-reverse">
                              <p class="text-red-600 text-sm mt4" v-if="errors[0]">{{ errors[0] }}</p>
                            </div>
                          </div>
                        </ValidationProvider>
                        <ValidationProvider name="Buyer Address" rules="required" v-slot="{ errors }">
                          <div class="mb-4">
                            <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                              <label class="text-sm font-medium w-full sm:w-40">Buyer Address:</label>

                              <input type="text" v-model="form.buyer.address" :class="[
                                'w-full border rounded px-3 py-2 focus:outline-none',
                                errors[0]
                                  ? 'border-red-500 focus:ring-2 focus:ring-red-400'
                                  : 'border-gray-300 focus:ring-2 focus:ring-blue-500'
                              ]" />
                            </div>

                            <div class="flex flex-row-reverse">
                              <p class="text-red-600 text-sm mt4" v-if="errors[0]">{{ errors[0] }}</p>
                            </div>
                          </div>
                        </ValidationProvider>

                        <ValidationProvider :name="`Buyer's ${vatLabel}`" rules="required" v-slot="{ errors }">
                          <div class="mb-4">
                            <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                              <label class="text-sm font-medium w-full sm:w-40">Buyer's {{ vatLabel }}:</label>

                              <input type="text" v-model="purchaseOrderPayload.vat" :class="[
                                'w-full border rounded px-3 py-2 focus:outline-none',
                                errors[0]
                                  ? 'border-red-500 focus:ring-2 focus:ring-red-400'
                                  : 'border-gray-300 focus:ring-2 focus:ring-blue-500'
                              ]" />
                            </div>

                            <div class="flex flex-row-reverse">
                              <p class="text-red-600 text-sm mt4" v-if="errors[0]">{{ errors[0] }}</p>
                            </div>
                          </div>
                        </ValidationProvider>

                        <ValidationProvider name="Seller Email" rules="required|email" v-slot="{ errors }">
                          <div class="mb-4">
                            <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                              <label class="text-sm font-medium w-32 sm:w-40 w-full">Seller:</label>

                              <input type="email" v-model="form.seller.email" :class="[
                                'w-full border rounded px-3 py-2 focus:outline-none',
                                errors[0]
                                  ? 'border-red-500 focus:ring-2 focus:ring-red-400'
                                  : 'border-gray-300 focus:ring-2 focus:ring-blue-500'
                              ]" />
                            </div>

                            <div class="flex flex-row-reverse">
                              <p class="text-red-600 text-sm mt4" v-if="errors[0]">{{ errors[0] }}</p>
                            </div>
                          </div>
                        </ValidationProvider>

                        <ValidationProvider name="Seller Address" rules="required" v-slot="{ errors }">
                          <div class="mb-4">
                            <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                              <label class="text-sm font-medium w-full sm:w-40">Seller Address:</label>

                              <input type="text" v-model="form.seller.address" :class="[
                                'w-full border rounded px-3 py-2 focus:outline-none',
                                errors[0]
                                  ? 'border-red-500 focus:ring-2 focus:ring-red-400'
                                  : 'border-gray-300 focus:ring-2 focus:ring-blue-500'
                              ]" />
                            </div>

                            <div class="flex flex-row-reverse">
                              <p class="text-red-600 text-sm mt4" v-if="errors[0]">{{ errors[0] }}</p>
                            </div>
                          </div>
                        </ValidationProvider>

                        <div>
                          <!-- Brand -->
                          <ValidationProvider name="Brand" rules="required" v-slot="{ errors }">
                            <div class="mb-4">
                              <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                                <label class="text-sm font-medium w-32 sm:w-40 w-full">Brand:</label>
                                <input v-model="purchaseOrderPayload.brand" type="text"
                                  :class="['w-full border rounded px-3 py-2 focus:outline-none', errors[0] ? 'border-red-500 focus:ring-2 focus:ring-red-400' : 'border-gray-300 focus:ring-2 focus:ring-blue-500']" />
                              </div>
                              <div class="flex flex-row-reverse">
                                <p class="text-red-600 text-sm mt-1" v-if="errors[0]">{{ errors[0] }}</p>
                              </div>
                            </div>
                          </ValidationProvider>
                          <ValidationProvider name="Desc./Part Number" rules="required" v-slot="{ errors }">
                            <div class="mb-4">
                              <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                                <label class="text-sm font-medium w-32 sm:w-40 w-full">Desc./Partnumber:</label>
                                <input v-model="purchaseOrderPayload.desc" type="text"
                                  :class="['w-full border rounded px-3 py-2 focus:outline-none', errors[0] ? 'border-red-500 focus:ring-2 focus:ring-red-400' : 'border-gray-300 focus:ring-2 focus:ring-blue-500']" />
                              </div>
                              <div class="flex flex-row-reverse">
                                <p class="text-red-600 text-sm mt-1" v-if="errors[0]">{{ errors[0] }}</p>
                              </div>
                            </div>
                          </ValidationProvider>

                          <ValidationProvider name="Condition" rules="required" v-slot="{ errors }">
                            <div class="mb-4">
                              <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                                <label class="text-sm font-medium w-32 sm:w-40 w-full">Condition:</label>
                                <div class="w-full flex flex-col sm:flex-row">
                                  <input v-model="purchaseOrderPayload.condition" type="text"
                                    :class="[' border rounded px-3 py-2 focus:outline-none', errors[0] ? 'border-red-500 focus:ring-2 focus:ring-red-400' : 'border-gray-300 focus:ring-2 focus:ring-blue-500']" />
                                  <a href="/grading-guidelines" target="_blank"
                                    class="text-sm text-red-600 hover:underline whitespace-nowrap mt-2 font-bold mx-0 sm:mx-3">
                                    Grading Guidelines
                                  </a>
                                </div>
                              </div>
                              <div class="flex flex-row-reverse">
                                <p class="text-red-600 text-sm mt-1" v-if="errors[0]">{{ errors[0] }}</p>
                              </div>
                            </div>
                          </ValidationProvider>

                          <!-- Condition Details -->
                          <ValidationProvider name="Condition Details" rules="" v-slot="{ errors }">
                            <div class="mb-4">
                              <div class="flex flex-col sm:flex-row items-start gap-3">
                                <label class="text-sm font-medium w-32 sm:w-40 w-full pt-2">
                                  Condition Details:
                                </label>

                                <div class="w-full">
                                  <textarea v-model="purchaseOrderPayload.conditionDetails" rows="3" maxlength="500"
                                    placeholder="Describe the item's condition (e.g. no scratches, fully functional, tested and working, original packaging included)"
                                    class="w-full border rounded px-3 py-2 text-sm"
                                    :class="[' border rounded px-3 py-2 focus:outline-none', errors[0] ? 'border-red-500 focus:ring-2 focus:ring-red-400' : 'border-gray-300 focus:ring-2 focus:ring-blue-500']">
                                  </textarea>
                                </div>
                              </div>
                              <div class="flex flex-row-reverse">
                                <p class="text-red-600 text-sm mt-1" v-if="errors[0]">{{ errors[0] }}</p>
                              </div>
                            </div>
                          </ValidationProvider>

                          <ValidationProvider name="Price" rules="required|numeric|positive" v-slot="{ errors }">
                            <div class="mb-4">
                              <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                                <label class="text-sm font-medium sm:w-40 w-full">Price:</label>
                                <div class="flex w-full">
                                  <!-- Amount input -->
                                  <input v-model="extractedPriceCurrency.price" type="number"
                                    class="rounded-l border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    :class="['w-full', errors[0] ? 'border-red-500 focus:ring-2 focus:ring-red-400' : 'border-gray-300 focus:ring-2 focus:ring-blue-500']" />

                                  <!-- Currency select -->
                                  <select v-model="extractedPriceCurrency.currency"
                                    class="rounded-r border border-gray-300 border-l-0 px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm">
                                    <option v-for="c in currencies" :key="c" :value="c.toLowerCase()">
                                      {{ c }}
                                    </option>
                                  </select>
                                </div>
                              </div>
                              <div class="flex flex-row-reverse">
                                <p class="text-red-600 text-sm mt-1" v-if="errors[0]">{{ errors[0] }}</p>
                              </div>
                            </div>
                          </ValidationProvider>

                          <ValidationProvider name="Quantity" rules="required|numeric|positive" v-slot="{ errors }">
                            <div class="mb-4">
                              <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                                <label class="text-sm font-medium w-32 sm:w-40 w-full">Quantity:</label>
                                <input v-model="purchaseOrderPayload.quantity" type="number"
                                  :class="['w-full border rounded px-3 py-2 focus:outline-none', errors[0] ? 'border-red-500 focus:ring-2 focus:ring-red-400' : 'border-gray-300 focus:ring-2 focus:ring-blue-500']" />
                              </div>
                              <div class="flex flex-row-reverse">
                                <p class="text-red-600 text-sm mt-1" v-if="errors[0]">{{ errors[0] }}</p>
                              </div>
                            </div>
                          </ValidationProvider>


                          <!-- Payment Method -->
                          <!-- <ValidationProvider name="Payment Method" rules="required" v-slot="{ errors }">
                            <div class="mb-4">
                              <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                                <label class="text-sm font-medium w-32 sm:w-40 w-full">Payment Method:</label>

                                <select v-model="purchaseOrderPayload.paymentMethod" :class="[
                                  'w-full border rounded px-3 py-2 focus:outline-none',
                                  errors[0]
                                    ? 'border-red-500 focus:ring-2 focus:ring-red-400'
                                    : 'border-gray-300 focus:ring-2 focus:ring-blue-500'
                                ]">
                                  <option disabled value="">Select payment method</option>
                                  <option value="1">Bank Transfer</option>
                                  <option value="2">Credit Card</option>
                                  <option value="3">Cash on Delivery</option>
                                </select>
                              </div>

                              <div class="flex flex-row-reverse">
                                <p class="text-red-600 text-sm mt-1" v-if="errors[0]">{{ errors[0] }}</p>
                              </div>
                            </div>
                          </ValidationProvider> -->


                          <!-- Delivery Method -->
                          <!-- <ValidationProvider name="Delivery Method" rules="required" v-slot="{ errors }">
                            <div class="mb-4">
                              <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                                <label class="text-sm font-medium w-32 sm:w-40 w-full">Delivery Method:</label>

                                <select v-model="purchaseOrderPayload.deliveryMethod" :class="[
                                  'w-full border rounded px-3 py-2 focus:outline-none',
                                  errors[0]
                                    ? 'border-red-500 focus:ring-2 focus:ring-red-400'
                                    : 'border-gray-300 focus:ring-2 focus:ring-blue-500'
                                ]">
                                  <option disabled value="">Select delivery method</option>
                                  <option value="4">Courier</option>
                                  <option value="5">Pickup</option>
                                  <option value="6">Same-Day Delivery</option>
                                </select>
                              </div>

                              <div class="flex flex-row-reverse">
                                <p class="text-red-600 text-sm mt-1" v-if="errors[0]">{{ errors[0] }}</p>
                              </div>
                            </div>
                          </ValidationProvider> -->

                          <!-- Delivery Date -->
                          <!-- <ValidationProvider name="Delivery Date" rules="required" v-slot="{ errors }">
                            <div class="mb-4">
                              <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                                <label class="text-sm font-medium w-32 sm:w-40 w-full">Delivery Date:</label>

                                <input v-model="purchaseOrderPayload.deliveryDate" type="date" :class="[
                                  'w-full border rounded px-3 py-2 focus:outline-none',
                                  errors[0]
                                    ? 'border-red-500 focus:ring-2 focus:ring-red-400'
                                    : 'border-gray-300 focus:ring-2 focus:ring-blue-500'
                                ]" />
                              </div>

                              <div class="flex flex-row-reverse">
                                <p class="text-red-600 text-sm mt-1" v-if="errors[0]">{{ errors[0] }}</p>
                              </div>
                            </div>
                          </ValidationProvider> -->

                          <!-- Delivery Address -->
                          <!-- <ValidationProvider name="Delivery Address" rules="required" v-slot="{ errors }">
                            <div class="mb-4">
                              <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                                <label class="text-sm font-medium w-32 sm:w-40 w-full">Delivery Address:</label>

                                <textarea v-model="purchaseOrderPayload.deliveryAddress" rows="2" :class="[
                                  'w-full border rounded px-3 py-2 focus:outline-none',
                                  errors[0]
                                    ? 'border-red-500 focus:ring-2 focus:ring-red-400'
                                    : 'border-gray-300 focus:ring-2 focus:ring-blue-500'
                                ]"></textarea>
                              </div>

                              <div class="flex flex-row-reverse">
                                <p class="text-red-600 text-sm mt-1" v-if="errors[0]">{{ errors[0] }}</p>
                              </div>
                            </div>
                          </ValidationProvider> -->

                          <!-- Delivery Instructions -->
                          <!-- <ValidationProvider name="Delivery Instructions" rules="" v-slot="{ errors }">
                            <div class="mb-4">
                              <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                                <label class="text-sm font-medium w-32 sm:w-40 w-full">Delivery Instructions:</label>

                                <textarea v-model="purchaseOrderPayload.deliveryInstructions" rows="2" :class="[
                                  'w-full border rounded px-3 py-2 focus:outline-none',
                                  errors[0]
                                    ? 'border-red-500 focus:ring-2 focus:ring-red-400'
                                    : 'border-gray-300 focus:ring-2 focus:ring-blue-500'
                                ]"></textarea>
                              </div>

                              <div class="flex flex-row-reverse">
                                <p class="text-red-600 text-sm mt-1" v-if="errors[0]">{{ errors[0] }}</p>
                              </div>
                            </div>
                          </ValidationProvider> -->

                          <!-- Contact Person for Delivery -->
                          <!-- <ValidationProvider name="Contact Person for Delivery" rules="" v-slot="{ errors }">
                            <div class="mb-4">
                              <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                                <label class="text-sm font-medium w-32 sm:w-40 w-full">Contact Person:</label>

                                <input v-model="purchaseOrderPayload.deliveryContactPerson" type="text" :class="[
                                  'w-full border rounded px-3 py-2 focus:outline-none',
                                  errors[0]
                                    ? 'border-red-500 focus:ring-2 focus:ring-red-400'
                                    : 'border-gray-300 focus:ring-2 focus:ring-blue-500'
                                ]" />
                              </div>

                              <div class="flex flex-row-reverse">
                                <p class="text-red-600 text-sm mt-1" v-if="errors[0]">{{ errors[0] }}</p>
                              </div>
                            </div>
                          </ValidationProvider> -->
                        </div>

                        <ValidationProvider name="Comments" rules="" v-slot="{ errors }">
                          <div class="mb-4">
                            <div class="flex flex-col sm:flex-row items-start gap-3">
                              <label class="text-sm font-medium w-32 sm:w-40 w-full">Comments:</label>
                              <textarea v-model="purchaseOrderPayload.comments" rows="4" maxlength="1000" 
                              placeholder="Enter delivery instructions, payment method, or any additional comments"
                              :class="[
                                'w-full border rounded px-3 py-2 focus:outline-none text-sm',
                                errors[0]
                                  ? 'border-red-500 focus:ring-2 focus:ring-red-400'
                                  : 'border-gray-300 focus:ring-2 focus:ring-blue-500'
                              ]"></textarea>
                            </div>
                            <div class="flex flex-row-reverse">
                              <p class="text-red-600 text-sm mt-1" v-if="errors[0]">{{ errors[0] }}</p>
                            </div>
                          </div>
                        </ValidationProvider>

                        <div v-if="poCreated" class="bg-green-200 rounded text-green-800 border  border-green-300">
                          <p class="p-4">
                            Your Purchase Order (PO #{{ poNumber }}) was successfully generated and sent to your email. You can also click
                            <strong class="cursor-pointer underline" @click="downloadPurchaseOrder">here</strong>
                            to download a copy.
                          </p>
                        </div>
                        <div v-else class="flex flex-row-reverse">
                          <button
                            class="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 flex items-center justify-center"
                            type="submit" :disabled="invalid || isCreatingTransaction">

                            <template v-if="isCreatingTransaction" class="flex">
                              <svg class="w-5 h-5 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none"
                                viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                  stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z">
                                </path>
                              </svg>
                              <span class="mx-2">Generating...</span>
                            </template>

                            <template v-else>
                              Generate Purchase Order
                            </template>
                          </button>
                        </div>
                      </div>
                    </form>
                  </ValidationObserver>
                </div>
              </div>
            </div>

            <div v-if="broadcastId && !user">
              <div class="grid grid-cols-2 px-4 py-1  sm:px-6">
                <div class="text-left">
                  <h3 class="text-lg leading-6 text-red-500 font-bold">Broadcast Details</h3>
                </div>
              </div>

              <div v-if="broadcast" class='px-6 my-6'>
                <div v-html="formattedSubject" class="break-words mb-6"></div>
                <br>
              </div>
              <div v-else class="px-6 my-6 space-y-4 animate-pulse">
                <!-- Title -->
                <div class="h-5 bg-gray-300 rounded w-48"></div>

                <!-- Rows -->
                <div class="space-y-2">
                  <div class="h-4 bg-gray-200 rounded w-32"></div>
                  <div class="h-4 bg-gray-200 rounded w-56"></div>
                  <div class="h-4 bg-gray-200 rounded w-40"></div>
                  <div class="h-4 bg-gray-200 rounded w-52"></div>
                </div>

                <!-- Paragraph block -->
                <div class="mt-4 space-y-2">
                  <div class="h-3 bg-gray-200 rounded"></div>
                  <div class="h-3 bg-gray-200 rounded w-4/5"></div>
                  <div class="h-3 bg-gray-200 rounded w-3/5"></div>
                </div>

                <!-- Contact block -->
                <div class="mt-4 space-y-2">
                  <div class="h-4 bg-gray-200 rounded w-64"></div>
                  <div class="h-3 bg-gray-200 rounded w-48"></div>
                  <div class="h-3 bg-gray-200 rounded w-36"></div>
                </div>

                <!-- Banner -->
                <div class="h-24 bg-gray-300 rounded"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </base-layout>
</template>

<script>

import { mapState } from 'vuex'
import BaseLayout from '@/components/BaseLayout.vue'

import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';

import store from '../store'
import eventBus from '../utils/eventBus'
import { mapActions } from 'vuex/dist/vuex.common.js';

const _ = require('lodash');


extend("required", {
  ...required,
  message: "{_field_} is required."
});
extend("email", {
  ...email,
  message: "Please enter a valid email."
});
extend("numeric", {
  validate: value => !isNaN(value),
  message: "{_field_} must be a number."
});
extend("positive", {
  validate: value => {
    const num = parseFloat(value);
    return !isNaN(num) && num > 0;
  },
  message: "{_field_} must be a number greater than 0."
});

export default {
  name: 'PurchaseOrderCreate',
  components: {
    BaseLayout,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    ...mapState(['user', 'broadcastMap']),
    extractedPriceCurrency() {
      const subject = this.broadcast?.subject || "";

      // get text after the last comma
      const lastPart = subject.split(",").pop().trim();

      // currency list
      const currencies = ["EUR", "USD", "GBP"];

      // extract currency
      let currency = (
        currencies.find(c =>
          new RegExp(`\\b${c}\\b`, "i").test(lastPart)
        ) || "EUR"
      ).toLowerCase();

      // extract price number
      let priceMatch = lastPart.match(/(\d+(\.\d+)?)/);
      let price = priceMatch ? parseFloat(priceMatch[0]) : 0;

      return { price, currency };
    },
    formattedSubject() {
      const message = this.broadcast?.messageFormatted || '';

      // Find first "Price:"
      const priceIndex = message.indexOf('Price:');
      if (priceIndex === -1) return '';

      // Find first literal "\n" after "Price:"
      const newlineIndex = message.indexOf('<br><br>', priceIndex); // note double backslash

      if (newlineIndex === -1) {
        return "test"; // no newline found
      }

      // Return from 0 to the newline
      return message.substring(0, newlineIndex);

    },
    vatLabel() {
      return this.user.country == "UK"
        ? "EORI"
        : this.user.country == "USA"
          ? "EIN"
          : "VAT";
    }
  },
  data() {
    return {
      broadcast: null,
      partId: null,
      companyId: null,
      part: null,
      company: null,
      contacts: null,
      editingSeller: false,
      isCreatingTransaction: false,
      purchaseOrderPayload: {
        purchaseNo: null,
        quantity: null,
        brand: null,
        desc: null,
        condition: null,
        conditionDetails: null,
        paymentMethod: '',
        deliveryMethod: '',
        deliveryDate: '',
        deliveryAddress: '',
        deliveryInstructions: '',
        deliveryContactPerson: '',
        comments: '',
        vat: null,
      },
      form: {
        buyer: {
          name: "",
          companyName: "",
          email: "",
          tel: "",
          address: ""
        },
        seller: {
          id: null,
          name: "",
          companyName: "",
          email: "",
          tel: "",
          address: ""
        },
      },
      currencies: ["EUR", "USD", "GBP"],
      poCreated: false,
      poNumber: null,
      poId: null,
      userInitialized: false,
    }
  },
  watch: {
    broadcast(newVal) {
      if (!newVal) return;
      if(!newVal.companyId) {
        this.$router.replace("/");
        return;
      }

      if(newVal.side == "WTB") {
        this.$router.replace("/");
        return;
      }

      const subject = newVal.subject;
      const colonIndex = subject.indexOf(':');

      this.purchaseOrderPayload.quantity = parseInt((newVal?.quantity || '').replace(/\D/g, ''), 10) || 0;
      this.purchaseOrderPayload.brand = newVal?.brand;
      this.purchaseOrderPayload.condition = newVal?.condition;
      this.purchaseOrderPayload.desc = newVal?.description;
      this.companyId = newVal?.companyId;

      let broadcastSenderRole = "seller";
      // let userRole = "buyer";


      this.form[broadcastSenderRole] = {
        id: newVal.contactId,
        name: newVal.contact?.name ?? "",
        companyName: newVal.company?.name ?? "",
        email: newVal.contact?.email ?? "",
        tel: newVal.contact?.tel ?? "",
        address: `${newVal.company.address}, ${newVal.company.country}`
      };

      // this.form[userRole] = {
      //   name: this.user?.name ?? "",
      //   companyName: this.user?.companyName ?? "",
      //   email: this.user?.email ?? "",
      //   tel: this.user?.tel ?? "",
      // };
    },
    part(newVal) {
      if (!newVal) return;

      const primaryContact = newVal.contacts?.find(c => c.contactType === 1)
        || newVal.contacts?.[0]
        || null;


      this.purchaseOrderPayload.brand = newVal?.manufacturer == "-" ? "" : newVal.manufacturer;
      this.purchaseOrderPayload.desc = newVal?.partNumber;
      this.purchaseOrderPayload.condition = newVal?.partCondition;
      this.extractedPriceCurrency.price = newVal?.price;
      this.companyId = newVal?.company.id;

      // formatNumber(Math.round(part.price * conversion))

      this.purchaseOrderPayload.quantity = newVal?.quantity;

      this.contacts = newVal.contacts;
      this.form["seller"] = {
        id: primaryContact.id,
        name: primaryContact?.name ?? "",
        companyName: newVal.company?.name ?? "",
        email: primaryContact?.email ?? "",
        tel: primaryContact?.tel ?? "",
        address: `${newVal.company.address}, ${newVal.company.country}`
      };

    },
    user(newVal) {
      if (this.userInitialized) return;

      if (!newVal || !newVal.id) {
        this.$router.replace("/");
        return;
      }

      this.userInitialized = true;

      this.form["buyer"] = {
        name: this.user?.name ?? "",
        companyName: this.user?.companyName ?? "",
        email: this.user?.email ?? "",
        tel: this.user?.tel ?? "",
        address: `${this.user.address}, ${this.user.country}`
      };    
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.purchaseNoInput) {
        this.$refs.purchaseNoInput.focus();
      }
    });
  },
  created() {
    this.getVat();

    const { bcId, partId } = this.$route.query;

    this.broadcastId = bcId;
    this.partId = partId;

    if (this.broadcastId && !isNaN(this.broadcastId)) {
      this.fetchBroadcastData()
    } else if (this.partId && !isNaN(this.partId)) {
      this.fetchPartData()
    }

  },

  methods: {
    ...mapActions(['createPurchaseOrder', 'getCompany', 'getPart']),
    async fetchBroadcastData() {
      try {
        const resp = await store.dispatch('getBroadcast', this.broadcastId)
        if (resp.status !== 200) {
          eventBus.$emit("createSnackbar", {
            type: "error",
            title: "Broadcast not found",
            body: resp.msg,
            timeoutInMS: 5000,
          })

          this.$router.push("/broadcasts");
          return;

        }
        this.broadcast = resp.broadcast

      } catch (e) {
        console.log("err", e)
      }
    },
    async fetchPartData() {
      try {
        const resp = await store.dispatch('getPart', this.partId)
        if (resp.status !== 200) {
          eventBus.$emit("createSnackbar", {
            type: "error",
            title: "Part not found",
            body: resp.msg,
            timeoutInMS: 5000,
          })
          this.$router.push("/parts");
          return;
        }
        this.part = resp.part
      } catch (e) {
        console.log("err", e)
      }
    },
    async handleSubmit() {
      const isValid = await this.$refs.observer.validate(); // or `validate()` from slot
      if (!isValid) return;
      this.onSubmit();
    },
    async onSubmit() {
      this.isCreatingTransaction = true;
      const payload = {
        form: this.form,
        purchaseOrderPayload: {
          ...this.purchaseOrderPayload,
          price: this.extractedPriceCurrency?.price,
          currency: this.extractedPriceCurrency?.currency,
          vatLabel: this.vatLabel
        },
        broadcastId: this.broadcastId,
        partId: this.partId,
        companyId: this.companyId
      };

      const resp = await this.createPurchaseOrder(payload);

      if (resp.data.status !== 201) {
        eventBus.$emit("createSnackbar", {
          type: "error",
          title: "Something went wrong",
          body: resp.data.error,
          timeoutInMS: 5000,
        })
      } else {
        eventBus.$emit("createSnackbar", {
          type: "success",
          title: "Purchase Order Generated",
          // body: "Purchase order created successfully",
        })
        this.poNumber = resp.data.poNumber;
        this.poId = resp.data.poId
        this.poCreated = true;
        // this.$router.push("/purchase-orders");
      }
      this.isCreatingTransaction = false;

    },
    async downloadPurchaseOrder() {
      try {
        const response = await this.$http.post(
          "/api/purchaseOrder/download",
          { poId: this.poId },
          { responseType: "blob" }
        );

        const blob = new Blob([response.data], {
          type: "application/pdf",
        });

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `PurchaseOrder-${this.poNumber}.pdf`;
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (err) {
        console.error(err);
      }
    },

    removeTelephoneFooter(message) {
      const keyword = "Telephone:";
      const index = message.indexOf(keyword);

      if (index === -1) return message;

      // find the newline at the end of the Telephone line
      const lineBreakAfterTelephone = message.indexOf("<br>", index);

      // if there is a newline after the Telephone line, keep everything up to it
      if (lineBreakAfterTelephone !== -1) {
        return message.substring(0, lineBreakAfterTelephone);
      }

      // if there is no newline, just keep the entire message (Telephone is last line)
      return message;



    },
    toggleSellerEdit() {
      if (this.editingSeller) {
        const selected = this.contacts.find(
          c => c.name === this.form.seller.name
        );

        if (selected) {
          this.form.seller.name = selected.name;
          this.form.seller.email = selected.email || "";
          this.form.seller.tel = selected.tel;
          this.form.seller.id = selected.id;
        }
        this.editingSeller = false;
      } else {
        this.editingSeller = true;
      }
    },
    navToBroadcast() {
      if (!this.broadcastId) return;
      this.$router.push({ path: `/broadcasts/${this.broadcastId}` });
    },
    sanitizePurchaseNo() {
      this.purchaseOrderPayload.purchaseNo =
      this.purchaseOrderPayload.purchaseNo.replace(/[^A-Za-z0-9\-/_ .]/g, '');
    },
    async getVat() {
      try {
        const { data } = await this.$http.get("/api/companies/vat");
        this.purchaseOrderPayload.vat = data.vat;
      } catch (error) {
        console.error("Failed to retrieve VAT.", error);
      }
    }

  },
}
</script>
